import type { LoginViewTranslation } from './loginView.translation.pl.ts';

export const loginViewTranslation: LoginViewTranslation = {
  title: 'Clique pour continuer',
  loading: 'Connexion...',
  buttons: {
    start: "C'est parti !",
    continue: 'Continuer',
    login: 'Se connecter',
  },
  toast: {
    loginError: 'Erreur de connexion',
    unknownError: "Une erreur inattendue s'est produite. Merci de réessayer.",
  },
  welcomeFirst: {
    title: 'Salut ! Ravi de te voir ici.',
    message: 'Ne perdons pas de temps. Lançons le jeu de recrutement.',
  },
  welcomeAdmin: {
    title: 'Bienvenue !',
    message: "Connecte-toi en tant qu'administrateur.",
  },
  welcomeAgain: {
    title: 'Ravi de te revoir ici.',
    message:
      "Je commençais à croire que je t'avais perdu de vue. Ne perdons pas de temps. Tu peux reprendre le jeu de recrutement.",
  },
};
